class CreateUserReq {
  constructor() {
    this.Id = undefined;
    this.Name = undefined;
    this.Nationality = undefined;
    this.NationalityGroup = undefined;
    this.Age = undefined;
    this.BirthdayDate = undefined;
    this.FoundBy = undefined;
    this.Gender = undefined;
    this.FirebaseId;
    this.Address = undefined;
    this.Number = undefined;
    this.UserType = undefined;
    this.isActivated = undefined;
    this.isAssessmentTherapist = undefined;
    this.isSoftDeleted = undefined;
    this.Email = undefined;
    this.NationalId = undefined;
    this.RelativeNumber = undefined;
    this.AccreditedPartners = undefined;
    this.ChronicDiseases = undefined;
    this.Sensetivity = undefined;
    this.Medications = undefined;
    this.isSuperAdmin = false;

    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined,
    };
  }
}

export default CreateUserReq;
